import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-3 px-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "time_start",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Fra tidspunkt", -1)
const _hoisted_3 = {
  key: 0,
  class: "m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block"
}
const _hoisted_4 = {
  key: 1,
  class: "py-2 px-6"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "time_end",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Til tidspunkt", -1)
const _hoisted_6 = {
  key: 0,
  class: "m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block"
}
const _hoisted_7 = {
  key: 2,
  class: "py-3 px-6"
}
const _hoisted_8 = { class: "block text-sm font-medium leading-6 text-secondary" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-2xl font-medium leading-8 text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "time_start",
              name: "time_start",
              type: "time",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromTime) = $event)),
              required: "",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fromTimeTouched = true)),
              class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 544), [
              [_vModelText, _ctx.fromTime]
            ]),
            (_ctx.fromTimeTouched && !_ctx.fromTime)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Angiv et gyldigt tidspunkt."))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "time_end",
              name: "time_end",
              type: "time",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toTime) = $event)),
              required: "",
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toTimeTouched = true)),
              class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 544), [
              [_vModelText, _ctx.toTime]
            ]),
            (_ctx.toTimeTouched && !_ctx.toTime)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Angiv et gyldigt tidspunkt."))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode("Tid registreret på dag "),
            (_ctx.gapMinutes !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(pause fratrækkes total tid)"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.timeSpentWithGap), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}